import { ReactNode, forwardRef } from 'react';

interface RightPanelProps {
  children: ReactNode;
}

export const RightPanel = forwardRef<HTMLElement, RightPanelProps>(
  ({ children }, ref) => {
    return (
      <aside
        ref={ref}
        className="flex w-full grow flex-col p-4 md:w-1/4 md:min-w-[300px] md:overflow-y-auto md:border-l-2 md:border-background-300 md:p-8"
      >
        {children}
      </aside>
    );
  },
);

RightPanel.displayName = 'RightPanel';
